import { useForm } from "@mantine/form";
import moment from "moment";

const useFormtemplates = (loginErr) => {
  const editProfile = useForm({
    initialValues: {
      editName: "",
      editEmail: "",
      editPhoneNumber: "",
      editPhoto: null,
    },
  });
  // 1234567890123456

  const uploadCardModel = useForm({
    initialValues: {
      cardOwner: "",
      cardNumber: "",
      cardExpMonth: "",
      cardExpYear: "",
      cardCvv: "",
    },
    clearInputErrorOnChange: false,
    validate: {
      cardOwner: (value) =>
        value.length > 2 ? null : "Please introduce the card's owner name",
      cardNumber: (value) => /^\d+$/.test(value) && value.length === 16 ? null : "Please introduce a valid card number",
      cardExpMonth: (value) => /^0*\d/g.test(value) && [1,2,3,4,5,6,7,8,9,10,11,12].includes(parseInt(value)) ? null : "Please introduce a valid month",
      cardExpYear: (value) => +value >= +moment().format("YY") && value.length === 2 ? null : "Please introduce a valid year",
      cardCvv: (value) => /\d+/.test(value) && value.length === 3 ? null : "Please introduce a valid cvv",
    },
  });

  const uploadAdressModel = useForm({
    initialValues: {
      street: "",
      number: "",
      apartment: "",
      block: "",
  },
    clearInputErrorOnChange: false,
    validate: {
      street: (value) => (value ? null : "Introduce a street"),
      number: (value, values) => (values.block && values.apartment) || value ? null : "Introduce a building number",
      apartment: (value, values) => values.number || (values.block && value) ? null : "Introduce an apartment number",
      block: (value, values) => values.number || (values.apartment && value) ? null : "Introduce a block",
    }
  })

  const orderModel = useForm({
    initialValues: {
      contactName: "",
      contactPhone: "",
      contactEmail: "",
      orderCreatedAt: "",
      addedProducts: [],
      additionalInfo: "",
      adress: {
        street: "",
        number: "",
        apartment: "",
        block: "",
      },
      paymentMethod: {
        paymentType: "cash",
        cardOwner: "",
        cardNumber: "",
        cardExpMonth: "",
        cardExpYear: "",
        cardCvv: "",
      },
      shippingMethod: "",
      total: null,
    },
    clearInputErrorOnChange: false,
    validate: {
      contactName: (value) => (value.length > 2 ? null : "Intorduce a name"),
      contactEmail: (value) => (value.length > 2 ? null : "Intorduce a name"),
      contactPhone: (value) =>
        value.length > 2 ? null : "Introduce a valid phone number",
      adress: {
        street: (value) => (value ? null : "Introduce a street"),
        number: (value, values) =>
          (values.adress.block && values.adress.apartment) || value ? null : "Introduce a building number",
        apartment: (value, values) => values.adress.number || (values.adress.block && value) ? null : "Introduce an apartment number",
        block: (value, values) =>
        values.adress.number || (values.adress.apartment && value) ? null : "Introduce a block",
      },
      // addedProducts: (value) =>
      //   value.length >= 1 ? null : "How did you get here without any products?",
      // total: (value) => (value ? null : "You need to buy something"),
      paymentMethod: {
        cardOwner: (value, values) => values.paymentMethod.paymentType !== "card" ? null  : value.length > 2 ? null :"Introduce a card owner name",
        cardNumber: (value, values) => values.paymentMethod.paymentType !== "card" ? null : value.length === 16 && /^\d+$/.test(value) ? null : "Introduce a card number ",
        cardExpMonth: (value, values) => values.paymentMethod.paymentType !== "card" ? null : /^0*\d/g.test(value) && [1,2,3,4,5,6,7,8,9,10,11,12].includes(parseInt(value)) ? null : "Introduce card's exp. month",
        cardExpYear: (value, values) => values.paymentMethod.paymentType !== "card" ? null : +value >= +moment().format("YY") && value.length === 2 ? null : "Introduce card's exp. year",
        cardCvv: (value, values) => values.paymentMethod.paymentType !== "card" ? null : /\d/g.test(value) && value.length === 3 ? null : "Introduce card's Cvv",
      }
    },
  });
  
  // DONE | rethink the validation for the order.adress if block is completed you don't need a number
  //        but an appartment number is needed and if you complete the number you don't need
  //        to complete the block  and appartment

  const sellingModel = useForm({
    initialValues: {
      brand: "",
      category: "",
      description: "",
      id: "",
      images: [],
      price: 0,
      rating: 0,
      stock: 1,
      title: "",
    },
    clearInputErrorOnChange: false,
    validate: {
      brand: (value) =>
        value.length > 1 ? null : "Please introduce a brand or add 'no brand'",
      category: (value) =>
        value ? null : "You have to choose a categpry from the list",
      description: (value) =>
        value.length > 200
          ? "Your description is too long"
          : value.length < 2
          ? "Your description is too short"
          : null,
      // description: (value) => (2 <= value.length ? null : "Your description is too short"),
      images: (value) =>
        value.length === 0
          ? "Please add some images of your product"
          : value.length > 4
          ? "Too many images"
          : value.filter((img) => img.size > 2097152).length 
          ? `These files are too large: ${sellingModel.values.images?.filter((img) => img.size > 2097152).map((item) => item.name)}`
          : null,
      title: (value) => (value.length >= 2 ? null : "Please introduce a title"),
    },
  });

  // 1048576 1mb size

  // const filteredBySizeImages = sellingModel.values.images?.filter((img) => img.size > 1048576)
  // const filter2 = filteredBySizeImages?.map((item) => item.name)
  // console.log(filter2)
  

  const commentModel = useForm({
    initialValues: {
      commentPosterId: "",
      commentPosterName: "",
      replies: [],
      commentStars: 0,
      commentTitle: "",
      commentDescription: "",
      commentPostedAt: "",
    },
    validateInputOnChange: false,
    validate: {
      commentTitle: (value) =>
        value.length >= 2 ? null : "Your comment needs a title",
      commentDescription: (value) =>
        value.length >= 2 ? null : "Your comment needs a description",
    },
  });

  const replyModel = useForm({
    initialValues: {
      replyPosterId: "",
      replyPosterName: "",
      replies: [],
      replyDescription: "",
      replyPostedAt: "",
    },
    validateInputOnChange: false,
    validate: {
      replyDescription: (value) =>
        value.length >= 2 ? null : "Your reply needs a description",
    },
  });

  const signupForm = useForm({
    initialValues: {
      displayName: "",
      password: "",
      confirmPassword: "",
      checkedTac: false,
      email: "",
      photoURL: "",
      phoneNumber: "",
      cards: [],
      adresses: [],
      favorites: [],
      cart: [],
      interests: [],
      userRating: 0,
    },
    clearInputErrorOnChange: false,
    validate: {
      displayName: (value) =>
        value.length > 2 ? null : "Introduce a name with more than 2 letters",
      password: (value) =>
        !/^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(value)
          ? "Your password should contain letters, numbers and symbols"
          : value.length < 5
          ? "Your password should contain at least 5 characters"
          : null,
      confirmPassword: (value, values) =>
        value !== values.password
          ? "Passwords need to match"
          : value.length < 6
          ? "Your password should contain at least 5 characters"
          : null,
      checkedTac: (value) =>
        value ? null : "Please read our terms and conditions and check the box",
      email: (value) =>
        /^\S+@\S+$/.test(value) ? null : "Introduce a valid email adress",
      // password: (value) =>
      //   value.length < 5
      //     ? "Your password should contain at least 5 characters"
      //     : null,
      // confirmPassword: (value) =>
      //   value.length < 6
      //     ? "Your password should contain at least 5 characters"
      //     : null,
    },
  });
  // console.log(loginErr)
  const loginForm = useForm({
    initialValues: {
      email: "",
      password: "",
    },
    clearInputErrorOnChange: false,
    validate: {
      // email: (value) => (loginErr ? "cant log in" : null),
      // password: (value) => (loginErr ? "cant log in" : null)
    },
  });

  return {
    editProfile,
    sellingModel,
    orderModel,
    signupForm,
    loginForm,
    uploadCardModel,
    commentModel,
    replyModel,
    uploadAdressModel
  };
};

export default useFormtemplates;
